export enum LocalStorageEnum {
  TEMP_EMAIL = 'tempEmail'
}
